import BlueProductFlag from 'src/components/restructure/common/BlueProductFlag/BlueProductFlag'

import { ProductTitle } from './ProductTitle'
import { ProductAction } from './ProductAction'
import { LastUnitsFlag } from './LastUnitsFlag'
import { CashbackHighlight } from './CashbackHighlight'
import { CashbackUserInfo } from './CashbackUserInfo/CashbackUserInfo'
import { useProductPageContext } from '../../contexts'
import { AlbumSkuSelector } from './AlbumSkuSelector'
import { ShippingCalculator } from './ShippingCalculator'

interface CmsSections {
  id: string
  name: string
  data: Record<string, any>
}

type Props = {
  cmsData?: {
    name: string
    sections?: CmsSections[]
  }
}

export function AlbumSidebar({ cmsData }: Props) {
  const { product, currentSku, isPreSale } = useProductPageContext()
  const albumSkuSelectorCMS = cmsData?.sections?.find(
    ({ name }) => name === '[Álbum Copa] - Seleção de Pacotes'
  )

  const albumPreSaleTextCMS = cmsData?.sections?.find(
    ({ name }) => name === '[Álbum Copa] - Texto pré-venda'
  )

  const {
    sellerDefault: {
      sellerOffer: { lastUnits },
    },
  } = currentSku

  const hasBlueProduct = product?.items?.find((item) =>
    item?.flags?.find((flag) => flag?.value === 'Produto Azul')
  )

  return (
    <>
      <CashbackHighlight />
      <ProductTitle isAlbum />
      <LastUnitsFlag isLastUnits={lastUnits} productId={currentSku.productId} />
      {albumSkuSelectorCMS && (
        <AlbumSkuSelector productsPack={albumSkuSelectorCMS.data.products} />
      )}
      <CashbackUserInfo />
      {hasBlueProduct && <BlueProductFlag style="badge" />}
      <ProductAction />
      <ShippingCalculator
        isPreSale={isPreSale}
        preSaleText={
          albumPreSaleTextCMS ? albumPreSaleTextCMS.data.description : ''
        }
      />
    </>
  )
}
